<script setup>
import {computed, onMounted, onUnmounted, ref} from 'vue';
import ISearch from "@/assets/img/icon/i-search.vue";
import {useAuthStore} from "@/store/auth";
import {useRouter} from "vue-router";
import {useStore} from "@/store";
import IChevron from "@/assets/img/icon/i-chevron.vue";

const searchText = ref('');
const props = defineProps({
  window: {
    type: Object,
    required: false, // window 객체가 없을 수도 있음
  }
});

// Define emit
const emit = defineEmits(['setModalData']);
const authStore = useAuthStore();
const store = useStore();
const router = useRouter();

// Pagenation Set
const selectedPage = ref(1);
const totalPage = computed(() => Math.ceil(store.langList.length / 10));
const pageNationArr = ref([]);

function setPageNation() {
  let temp = [];
  const firstPage = 10 * (selectedPage.value - 1) + 1;
  const lastPage = 10 * selectedPage.value;

  for (let i = 1; i <= totalPage.value; i++) {
    if (i >= firstPage && i <= lastPage) {
      temp.push(i);
    }

    if (temp.length === 10) {
      break;
    }
  }

  pageNationArr.value = temp;
}

function movePageByDirection(dir) { // false: prev, true: next
  if (!dir) {
    if (selectedPage.value - 1 === 0) {
      return;
    }

    selectedPage.value -= 1;

  }

  if(dir) {
    if (selectedPage.value === totalPage.value) {
      return;
    }
    selectedPage.value += 1;
  }
}

// emit for setting modal data
function setModalData(action, name = '', parameter = '', id = null, countType = null) { // from: false => button(add), true => list(edit)
  emit('setModalData', {
    modalType: 'language',
    action: action,
    name: name,
    parameter: parameter,
    id: id,
    countType: countType,
  });
}

onMounted(async () => {
  if (!authStore.userId) { // JWT 만료시 로그인 페이지 ㄱㄱ
    await router.push({name: 'Login'});
    return;
  }

  if (store.langList.length === 0) {
    await store.getLanguageList();
  }
  setPageNation();
})

onUnmounted(async () => {
  await store.getLanguageList();
})
</script>

<template>
  <div id="languageSetting">
    <div class="top">
      <h3>언어 관리</h3>
      <button class="btn size_24 primary" @click="setModalData(false)">언어 추가</button>
    </div>

    <div class="search_container">
      <input type="text" placeholder="검색어를 입력하세요." v-model="searchText"
             @keydown.enter="store.getLanguageList(searchText)"/>
      <i-search class="icon size_20 blue"/>
    </div>

    <span class="total_count">{{ store.langList.length }}개의 언어</span>

    <div v-for="(ll, index) in store.langList" class="table_row" :key="index"
         @click="setModalData(true, ll.name, ll.parameter, ll.id, ll.count_type)">
      <div class="index">{{ store.modifyIndex(index + 1) }}</div>
      <span class="title">{{ ll.name }}</span>
      <span class="parameter">{{ ll.parameter }}</span>
      <div class="date">{{ store.modifyDateToYMD(ll.created_at) }}</div>
    </div>

    <div v-if="pageNationArr.length > 1" class="page_nation" style="margin-top: 80px;">
      <div class="page_move" @click="movePageByDirection(false)">
        <i-chevron class="icon size_20 left"/>
      </div>

      <p v-for="(pageNationArr, index) in pageNationArr" :key="index" class="page_num"
         :class="{ 'selected' : selectedPage === pageNationArr }" @click="selectedPage = pageNationArr">
        {{ pageNationArr }}</p>

      <div class="page_move" @click="movePageByDirection(true)">
        <i-chevron class="icon size_20 right"/>
      </div>
    </div>
  </div>
</template>
